module.exports = __webpack_public_path__ + "img/benefit-info.3e215301.svg";